export default __webpack_public_path__ + "static/offcentreringtube-b9e6a3015133f4a7c5cf0cbb5f01d543.png";